import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import { Card, Col, Row } from "react-bootstrap"

import { Common } from "../../../helper"
import { DashBoardPieCharts, Header, LoadingSpinner } from "../../Shared";
import { CommonModal, Demographics } from "./";
import { ComparisonNames, FilterComparisonMain, FilterNames, SpecifyPieChartName, CheckAppliedFilter } from "../";

const DemographicsLanding = () => {
  const [comparisonGroup, setComparisonGroup] = useState();
  const [subjects, setSubjects] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [generateReport, setGenerateReport] = useState(false)
  const [selectedFilter, setSelectedFilter] = useState([]);
  const [selectedComparision, setSelectedComparision] = useState();
  const [selectedClassName, setSelectedClassName_] = useState();
  const [mainPage, setMainPage] = useState(true);
  const [upComing, setUpComing] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isvalue, setValue] = useState();

  let pupilProgress = useSelector((state) => state.pupilProgress.pupilFilter.info);
  const compSelected = useSelector((state) => state.pupilProgress.BPComparisonSelect)
  const isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed);

  const getProgress = (progress) => {
    setSubjects(progress)
    setGenerateReport(true)
    setIsLoading(false)
  }

  const setSelectedClassName = (e) => {
    setSelectedClassName_(e)
  }

  const calculateSum = (piechart) => {
    return piechart.reduce((sum, entry) => sum + entry.value, 0);
  };

  useEffect(() => {
    setComparisonGroup(Common.AllGroups);
  }, [])

  useEffect(() => {
    CheckAppliedFilter(setSelectedComparision, compSelected, setSelectedFilter, selectedClassName, pupilProgress);
  }, [subjects])

  const styles = {
    mainPageMainDiv: {
      display: "flex", flexWrap: "wrap", justifyContent: "space-around"
    },
    pieMainDiv: {
      display: "flex", flexDirection: "column", alignItems: "center", minWidth: "250px", padding: "10px"
    },
    chartText: {
      fontWeight: "bold", fontSize: "16px"
    },
    // allTypeDiv: { display: "flex", overflow: "auto" },
    // mainDiv: { background: "none", width: "-webkit-fill-available", minWidth: "350px" },
    allTypeDiv: { display: "flex", flexWrap: "wrap" },
    mainDiv: { background: "none", width: "-webkit-fill-available", minWidth: "350px", flexBasis: "350px", flexGrow: 1 },
    secondaryDiv: { background: "#fff", minWidth: "340px", width: "-webkit-fill-available" },
    noPupilDiv: {
      display: "flex", alignItems: "center", justifyContent: "center"
    },
    button: {
      background: "none", cursor: "pointer"
    }
  }

  return (
    <div className="bigPictureEOYP">
      <div className="Page-layout">
        <div className="Page-header">
          <Header />
          <div className="Page-body" style={{ paddingRight: !isNavCollapsed ? "250px" : "75px" }}>
            <div className="EOYP-header">
              <div className="Page-name">
                <span className="EOYP-name-firstText">{Common.BigPicturePageName}</span>
                <span className="EOYP-name-secondText">{Common.Demographics}</span>
              </div>
              <div className="EOYP-title">
                <span className="EOYP-titleText">{Common.Demographics}</span>
              </div>
              <div className="EOYP-subtitle">
                <span className="EOYP-subtitleText">{Common.DemographicsSubText}</span>
              </div>
            </div>
            <div className="EOYP-comparison">
              <FilterComparisonMain setSubjects={getProgress} number={4} setIsLoading={setIsLoading} isGLD={true} setSelectedClassName={setSelectedClassName} selectedBaseLine={""} isSubject={false} setMainPage={setMainPage} setUpComing={setUpComing} />
            </div>
            <div>
              {
                isLoading ? <LoadingSpinner /> : (generateReport ? (<Row style={{ marginTop: "20px" }}>
                  <Col sm={12}>
                    <div className="bigPictureDataView-EOYP">
                      <Row>
                        <Col sm={9}>
                          <div className="title">
                            <span className="dataView-title">{`${Common.Demographics}: `}</span>
                            <span className="dataView-title">{comparisonGroup}</span>
                          </div>
                          <div className="subtitles1">
                            <span className="dataView-subtitle">{`${Common.Comparison}: `}</span>
                            <span className="dataView-subtitle2">{ComparisonNames(selectedComparision)}</span>
                          </div>
                          <div className="subtitles2">
                            <span className="dataView-subtitle">{`${Common.AppliedFilters}: `}</span>
                            <span className="dataView-subtitle2">{selectedFilter && FilterNames(selectedFilter)}</span>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12}>
                          {upComing ? <h1>{Common.ComingSoon}</h1> : <div>
                            {subjects && mainPage ? <div style={styles.mainPageMainDiv}>
                              {Object.values(subjects).map((item) => {
                                return Object.entries(item).map(([key, value], index) => {
                                  return (
                                    <div key={index} style={styles.pieMainDiv}>
                                      <span style={styles.chartText}>{`${SpecifyPieChartName(key)} (${value.totalCount})`}</span>
                                      {calculateSum(value.piechart) > 0 ? (
                                        <button onClick={() => { setValue(value); setShowModal(true); }} style={styles.button}>
                                          <DashBoardPieCharts item={value.piechart} mainIndex={true} isBackGround={false} />
                                        </button>
                                      ) : (
                                        <h6>{Common.NoPupils}</h6>
                                      )}
                                    </div>
                                  );
                                });
                              })}
                            </div> : <>
                              {Object.entries(subjects).map(([key, value], index) => {
                                if (key === Common.Main) {
                                  return (
                                    <div key={index} style={styles.allTypeDiv}>
                                      {Object.entries(value).map(([subkey, subvalue], subIndex) => (
                                        <Card className="d-flex dashBoardDemographyMain" style={styles.mainDiv} key={subIndex}>
                                          <div className="demographyMain" style={styles.secondaryDiv}>
                                            <div className="demographyTitle">{`${SpecifyPieChartName(subkey)} (${subvalue?.totalCount})`}</div>
                                            <div className="d-flex justify-content-evenly pieChartPart">
                                              {calculateSum(subvalue.piechart) > 0 ? (
                                                <button onClick={() => { setValue(subvalue); setShowModal(true); }} style={styles.button}>
                                                  <DashBoardPieCharts item={subvalue.piechart} mainIndex={true} isBackGround={true} />
                                                </button>
                                              ) : (
                                                <h6>{Common.NoPupils}</h6>
                                              )}
                                            </div>
                                          </div>
                                        </Card>
                                      ))}
                                    </div>
                                  );
                                }
                                else {
                                  return (
                                    <div key={index}>
                                      {
                                        Object.entries(value).map(([subkey, subvalue], subIndex) => <Demographics keyName={subkey} Items={subvalue} key={subIndex} isBackGround={false} mainIndex={false} />)
                                      }
                                    </div>
                                  )
                                }
                              })}
                            </>}
                          </div>}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>) : "")
              }
            </div>
          </div>
        </div>
      </div>
      <CommonModal showModal={showModal} value={isvalue?.piechart} setShowModal={setShowModal} />
    </div >
  )
}

export { DemographicsLanding }
